import { Pipe, PipeTransform } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { isObservable, Observable, of } from 'rxjs';
import { switchMap } from 'rxjs/operators';

@Pipe({
   name: 'acdLineToDisplayNumber$',
})
export class AcdLineToDisplayNumberPipe implements PipeTransform {
   private static readonly SOFTPHONE_MAGICNUMBER = '117865863052';

   constructor(private translateService: TranslateService) {}

   transform(acdLine: string | Observable<string>): Observable<string> {
      let acdLine$: Observable<string>;
      if (isObservable(acdLine)) {
         acdLine$ = acdLine;
      } else {
         acdLine$ = of(acdLine);
      }

      return acdLine$.pipe(
         switchMap((device) => {
            if (device.toString().startsWith(AcdLineToDisplayNumberPipe.SOFTPHONE_MAGICNUMBER)) {
               return this.translateService.get('samwin.softphone.device_number');
            }
            return of(device.toString());
         })
      );
   }
}
